// Generated by Copilot- Start
import React from "react";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvModal from "@directv-digital/dds.ui.dtv-modal";
import { modalLinkPosition } from "src/utils/link-click";
import DtvDivider from "@directv-digital/dds.ui.dtv-divider";
import { IChnlInteractiveThemeUI } from "lib/helper/channel-interactive-tool-theme";
import { SvodTileV2 } from "./SvodBannerV2";
import ModalChannelHeader from "./shared/ModalChannelHeader";
import ModalPackageSection, { PackageEntry } from "./shared/ModalPackageSection";
import { parseModalContent } from "../utils/modal-content-parser";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import { dtvModalRootSx } from "../styles/component-styles";

interface SvodModalV2Props {
  open: boolean;
  svod?: SvodTileV2;
  onClose: () => void;
  theme?: IChnlInteractiveThemeUI;
  pkgModalContent?: any;
  chnlSrc?: string;
}

const SvodModalV2: React.FC<SvodModalV2Props> = ({ open, svod, onClose, theme: _theme, pkgModalContent, chnlSrc }) => {
  try {
    if (!svod) {
      return null;
    }

    // Convert signature and genre package lists to PackageEntry format
    const signaturePackages: PackageEntry[] = (svod.signaturePackageList || []).map(pkg => ({
      ...pkg,
      // Use deviceIncludedText if available, otherwise fall back to existing packageLegal or default
      packageLegal: svod.deviceIncludedText || pkg.packageLegal || "Included in package"
    }));

    const genrePackages: PackageEntry[] = svod.genrePackageList || [];

    // Determine if this is satellite variant
    const isSatellite = chnlSrc === "dtvClup";

    // Parse CMS content using centralized helper with package counts for singular/plural
    const { signaturePkgTxt, genrePkgTxt } = parseModalContent(
      pkgModalContent,
      isSatellite
    );

    return (
      <DtvModal
        open={open}
        handleClose={onClose}
        // WAT-12797 (AC7): the close X reports the same modal_<category>_<name> as the CTAs inside.
        closeButtonProps={{ "data-linkposition": modalLinkPosition(`svod_${svod?.name}`) }}
        sx={dtvModalRootSx}
      >
        <DtvBox sx={{
 width: "100%",
height: "100%",
p: "1px"
}}>
          {/* SVOD Logo and Title */}
          <ModalChannelHeader
            logo={svod.icon}
            label={svod.name}
            logoAlt={svod.name}
            logoSize="large"
            gap="30px"
            labelStyles={{ fontSize: "28px !important" }}
          />

          {/* Package Sections (Signature + Genre) */}
          <DtvBox>
            {(signaturePackages.length > 0 || genrePackages.length > 0) && (
              <DtvDivider sx={{
 mt: {
 xs: "10px",
md: "15px"
},
mb: {
 xs: "10px",
md: "15px"
}
}} />
            )}

            {/* Signature Packages Section */}
            <ModalPackageSection
              id="package-mapping-with-channel"
              heading={signaturePkgTxt}
              packages={signaturePackages}
              channelName={svod.name}
              channelCategory="svod"
              topMargin="0px"
              headingSx={{ fontSize: "24px !important" }}
              packageGap="15px"
            />

            {/* Genre Packages Section */}
            <ModalPackageSection
              id="package-mapping-with-channel-genre"
              heading={genrePkgTxt}
              packages={genrePackages}
              channelName={svod.name}
              channelCategory="svod"
              showDivider={signaturePackages.length > 0}
              topMargin="26px"
              headingBottomMargin="15px"
              headingSx={{ fontSize: "24px !important" }}
              packageGap="15px"
              dividerSx={{
 mt: {
 xs: "10px",
md: "15px"
},
mb: {
 xs: "10px",
md: "15px"
}
}}
            />
          </DtvBox>
        </DtvBox>
      </DtvModal>
    );
  } catch (error) {
    console.error("Error in SvodModalV2 >> ", error);
    return <ErrorDisplay error={error} component="SVOD Modal V2" />;
  }
};

export default React.memo(SvodModalV2);
// Generated by Copilot- End
